import { useEffect, useState } from 'react';
import { usePortal } from '../../../hooks/useNavConfig';
import { useAppDispatch } from '../../../hooks';
import { setOnboardingProgress, setCoac0001Variant, setCoac0002Variant } from '../../../reducers/OnboardingProgress';
import { captureException } from '../../../utils/sentryAPI';
import { COAC0001_TREATMENT_HUB_USER_ATTRIBUTE_KEY, COAC0002_TREATMENT_HUB_USER_ATTRIBUTE_KEY, getTreatmentGroupsFromUserAttributes } from './utils/userAttributes';
import { useIsUngated } from '../../../hooks/useIsUngated';
import { REMOVE_GROWTH_PLAN_GATE } from '../../../constants/gates';
import { withErrorBoundary } from '../../../components/ErrorBoundary';
const isHubspotOrigin = origin => {
  return origin.includes('https://') && origin.includes('hubspot') && (origin.includes('app') || origin.includes('local'));
};
const isCorrectOnboardingProgressPayload = args => {
  return typeof args === 'object' && args !== null && 'progress' in args && 'selectedView' in args && 'groupKey' in args;
};
export const OnboardingProgressListener = ({
  isEnrolledInOnboarding
}) => {
  const dispatch = useAppDispatch();
  const {
    portalId
  } = usePortal();
  const [coac0001Group, setCoac0001Group] = useState(undefined);
  const [coac0002Group, setCoac0002Group] = useState(undefined);
  const isUngatedToGrowthPlanRemoval = useIsUngated(REMOVE_GROWTH_PLAN_GATE);
  useEffect(() => {
    if (isEnrolledInOnboarding && portalId && !isUngatedToGrowthPlanRemoval) {
      getTreatmentGroupsFromUserAttributes().then(treatmentGroups => {
        const coac0001TreatmentGroup = treatmentGroups[COAC0001_TREATMENT_HUB_USER_ATTRIBUTE_KEY];
        const coac0002TreatmentGroup = treatmentGroups[COAC0002_TREATMENT_HUB_USER_ATTRIBUTE_KEY];
        setCoac0001Group(coac0001TreatmentGroup);
        setCoac0002Group(coac0002TreatmentGroup);
      }).catch(error => {
        captureException(error);
      });
    }
  }, [isEnrolledInOnboarding, portalId, isUngatedToGrowthPlanRemoval]);
  useEffect(() => {
    if (!isEnrolledInOnboarding || !portalId) {
      return;
    }
    if (coac0001Group === undefined) {
      return;
    }
    if (coac0002Group === undefined) {
      return;
    }
    dispatch(setCoac0001Variant(coac0001Group));
    dispatch(setCoac0002Variant(coac0002Group));
    const setupGuideUiListener = evt => {
      var _evt$data;
      if (isHubspotOrigin(evt.origin) && ((_evt$data = evt.data) === null || _evt$data === void 0 ? void 0 : _evt$data.type) === 'onboarding-progress' && isCorrectOnboardingProgressPayload(evt.data.payload)) {
        dispatch(setOnboardingProgress(evt.data.payload));
      }
    };
    window.addEventListener('message', setupGuideUiListener);

    // eslint-disable-next-line consistent-return
    return () => {
      window.removeEventListener('message', setupGuideUiListener);
    };
  }, [dispatch, isEnrolledInOnboarding, portalId, coac0001Group, coac0002Group]);
  return null;
};
export default withErrorBoundary(OnboardingProgressListener, {
  boundaryName: 'OnboardingProgressListener'
});